<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <ngx-smart-modal #planModal identifier="planModal">
          <div *ngIf="planModel">
            <h4 class="card-title">Editar/Novo Plano</h4>
            <form method="get" action="/" class="form-horizontal" id="planForm">
              <input class="form-control" type="hidden" name="id" [(ngModel)]="planModel.id" required #id="ngModel">
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Id</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" name="seoName" [(ngModel)]="planModel.seoName" required
                      #seoName="ngModel">
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Nome do Plano</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" name="name" [(ngModel)]="planModel.name" required
                      #name="ngModel">
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Preço</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" name="price" [(ngModel)]="planModel.price" required
                      #price="ngModel">
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Até Qtos Pedidos</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" name="requests" [(ngModel)]="planModel.requests"
                      #requests="ngModel">
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Descrição Curta</label>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" name="description" [(ngModel)]="planModel.description"
                      #description="ngModel">
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Período</label>
                  <div class="col-sm-10">
                    <select class="form-control" name="period" [(ngModel)]="planModel.period">
                      <option [value]="1">Mensal</option>
                      <option [value]="6">Semestral</option>
                      <option [value]="12">Anual</option>
                    </select>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Tipo de Plano</label>
                  <div class="col-sm-10">
                    <select class="form-control" name="monetizationType" [(ngModel)]="planModel.monetizationType">
                      <option [value]="0">Valor Fixo</option>
                      <option [value]="1">Percentual</option>
                    </select>
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Ordem</label>
                  <small>como vai aparece na lista de planos</small>
                  <div class="col-sm-10">
                    <input class="form-control" type="text" name="order" [(ngModel)]="planModel.order" required
                      #order="ngModel">
                  </div>
                </div>
              </fieldset>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Plano Ativo</label>
                  <div class="col-sm-10">
                    <label class="switch">
                      <input type="checkbox" name="scriptValidated" [checked]="planModel.active"
                        (change)="planModel.active = !planModel.active">
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </fieldset>
              <hr>
              <fieldset class="form-group" *ngIf="featureList != null && isEditPlan">
                <div class="row" style="margin: 0 45px;margin-left: 0;">
                  <div class="col-lg-12 col-md-12">
                    <hr>
                    <label class="control-label">Feature:</label>
                    <br>
                    <small>Para add uma nova feature, não basta só selecionar, precisa clicar em "+
                      feature"</small>
                  </div>
                  <div class="col-lg-10 col-md-10">
                    <select class="form-control" name="featureId" [(ngModel)]="planModel.featureId">
                      <option *ngFor="let feature of featureList" [ngValue]="feature.id">
                        {{feature.name}}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-2 col-md-2">
                    <button class="btn btn-info btn-sm" type="button" (click)="AddRemoveFeature('plus')"> +
                      feature</button>
                  </div>
                  <div class="card-content">
                    <div class="col-lg-10 col-md-10">
                      <div *ngFor="let ngo of planModel.features;let i = index;trackBy: trackFeatureById">
                        <div class="col-lg-12" style="border: 1px gray dashed;">
                          {{i}}: {{planModel.features[i].name}} ({{planModel.features[i].id}})
                        </div>
                        <br>
                      </div>
                    </div>
                    <div class="col-lg-2 col-md-2">
                      <button *ngIf="planModel.features != null && planModel.features.length > 0"
                        class="btn btn-info btn-sm btn-danger" type="button" (click)="AddRemoveFeature('less')"> -
                        feature</button>
                    </div>
                  </div>
                  <div class="col-lg-12 col-md-12">
                    <hr>
                  </div>
                </div>
              </fieldset>
              <hr>
              <fieldset>
                <div class="form-group">
                  <label class="col-sm-2 control-label">Detalhes</label>
                  <div class="col-sm-10">
                    <table>
                      <tr *ngFor="let detail of planModel.details; let i = index" [attr.data-index]="i"
                        style="margin-bottom: 10px;">
                        <td>{{detail}}</td>
                        <td><button (click)="removeDetail(i,detail)" class="btn btn-danger btn-sm">Excluir</button></td>
                      </tr>
                    </table>
                    <input class="form-control" type="text" name="newDetail" [(ngModel)]="planModel.newDetail"
                      #newDetail="ngModel">
                    <button (click)="addDetail(planModel.newDetail)" class="btn btn-warning btn-fill btn-sm">+
                      Detalhe</button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
          <button type="button" (click)="savePlan()" style="float:right" class="btn btn-info btn-fill">Salvar</button>
        </ngx-smart-modal>
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Planos Polen</h4>
            <div class="text-right">
              <button type="button" (click)="createPlan()" class="btn btn-info btn-fill">Novo Plano</button>
            </div>
          </div>
          <div class="card-content table-full-width">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Name</th>
                  <th>Valor</th>
                  <th>Período</th>
                  <th>Ordem</th>
                  <th>Tipo</th>
                  <th>Ativo</th>
                  <th class="text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let p of planList">
                  <td>{{p.seoName}}</td>
                  <td>{{p.name}}</td>
                  <td>{{p.price | number}}</td>
                  <td>{{p.period}}</td>
                  <td>{{p.order}}</td>
                  <td>{{p.monetizationType}}</td>
                  <td class="text-right">
                    <div [ngSwitch]="p.active">
                      <div *ngSwitchCase="true">
                        <input type="checkbox" class="switch-plain" checked="">
                      </div>
                      <div *ngSwitchDefault>
                        <input type="checkbox" class="switch-plain">
                      </div>
                    </div>
                  </td>
                  <td class="td-actions text-right">
                    <button (click)="editPlan(p)" class="btn btn-sm">Editar</button>&nbsp;
                    <!-- <button class="btn btn-sm">Analytics</button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>